<div class="w-full mx-auto">
  <div class="flex flex-wrap">
    <div class="authBackground" [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"></div>

    <div class="relative w-full">
      <div class="login-card flex-col">
        <div class="mb-12 text-center">
          <img src="assets/images/other-images/Halo.svg" alt="Halo dot" />
        </div>
        <div class="login-main text-center">
          <h4 class="font-bolder mb-6">{{ 'DOWNTIME_REDIRECT.HEADER' | translate }}</h4>
          <div class="mb-6">
            <strong class="title">{{ 'DOWNTIME_REDIRECT.TITLE' | translate }}</strong>
          </div>
          <div class="mb-4">
            <p><strong class="description">{{ 'DOWNTIME_REDIRECT.DOWNTIME' | translate }}</strong></p>
            <ul>
              <li><strong>{{ 'DOWNTIME_REDIRECT.OPERATION1' | translate }}</strong> 00:00 - 02:00</li>
              <li>
                <strong>{{ 'DOWNTIME_REDIRECT.OPERATION2' | translate }}</strong>
                {{ 'DOWNTIME_REDIRECT.OPERATION3' | translate }}
              </li>
            </ul>
            <p class="mt-4">{{ 'DOWNTIME_REDIRECT.OUTSIDE_HOURS' | translate}}</p>
          </div>
          <div class="content mb-4">
            {{ 'DOWNTIME_REDIRECT.SUGGESTION_PART1' | translate }}
            <a [routerLink]="link.contact" class="ml-1"> {{ 'DOWNTIME_REDIRECT.CONTACT_US' | translate }}</a> or
            <br />
            <a [routerLink]="link.submit" class="ml-1">{{ 'DOWNTIME_REDIRECT.SUBMIT_REQUEST' | translate }}</a>
            {{ 'DOWNTIME_REDIRECT.SUGGESTION_PART2' | translate }}
          </div>
          <div class="content"><b>{{ 'DOWNTIME_REDIRECT.APOLOGY_1' | translate }}</b></div>
          <div class="content mb-6"><b>{{ 'DOWNTIME_REDIRECT.APOLOGY_2' | translate }}</b></div>
          <div>
            <img src="assets/images/other-images/cogs.png" alt="Scheduled Downtime" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
